import React, { useEffect } from 'react';
import {
  Dialog,
  IconButton,
  Typography,
  DialogBody,
  DialogHeader,
  DialogFooter,
} from '@material-tailwind/react';

import { XMarkIcon } from '@heroicons/react/24/outline';
import { useForm } from 'react-hook-form';
import InputGlobal from '../InputGlobal';
import ButtonGlobal from '../ButtonGlobal';
import MsgSucess from '../MsgSucess';
import { useCadastroUser } from '../../hook/useFuncPatch';

import { useErroControlManul } from '../../hook/useErroControlManul';

export function ModalCreateuser({ modal, handleModal }) {
  const {
    register,
    handleSubmit,
    reset,
    clearErrors,
    setError,
    formState: { errors },
  } = useForm();
  const { result, pathsCall, resetInfo: resetCadastro } = useCadastroUser();
  const { useArrayErrorForm } = useErroControlManul();

  const onSubmit = (data) => {
    pathsCall(data);
  };

  useEffect(() => {
    return () => clearErrors();
  }, []);

  useEffect(() => {
    if (result?.error) {
      useArrayErrorForm(result?.error, setError);
    }
  }, [result]);

  const resetInfo = () => {
    reset();
    resetCadastro();
    handleModal();
  };

  return (
    <>
      <Dialog
        size="sm"
        open={modal}
        handler={resetInfo}
        className={`p-4 bg-lightMenu dark:bg-none dark:bg-darkColorBg`}
      >
        <DialogHeader className="relative m-0 block">
          <Typography variant="h4" className="text-black dark:text-darkText">
            Cadastrar Usuario
          </Typography>
          <IconButton
            size="sm"
            variant="text"
            className="!absolute right-3.5 top-3.5"
            onClick={resetInfo}
          >
            <XMarkIcon className="h-4 w-4 stroke-2 dark:text-darkText" />
          </IconButton>
        </DialogHeader>
        <DialogBody className="space-y-4 pb-6">
          <form className="flex flex-col gap-5" onSubmit={handleSubmit(onSubmit)}>
            <div>
              <InputGlobal
                formCamp="username"
                type="text"
                label="Usuario "
                placeholder="Digite seu usuario"
                register={register}
                validations={{ required: true }}
                required={true}
                errors={errors?.username ? errors : false}
                css="w-full"
                error={result?.error}
              />
            </div>
            <div className="flex gap-2">
              <InputGlobal
                formCamp="first_name"
                type="text"
                label="Nome "
                placeholder="Digite seu nome"
                register={register}
                validations={{ required: true }}
                required={true}
                errors={errors?.first_name ? errors : false}
                css="w-full"
                error={result?.error}
              />
              <InputGlobal
                formCamp="last_name"
                type="text"
                label="Sobrenome "
                placeholder="Digite seu sobrenome"
                register={register}
                validations={{ required: true }}
                required={true}
                errors={errors?.last_name ? errors : false}
                css="w-full"
                error={result?.error}
              />
            </div>
            <div>
              <InputGlobal
                formCamp="password"
                type="password"
                label="Senha "
                placeholder="Digite sua senha"
                register={register}
                validations={{ required: true }}
                required={true}
                errors={errors?.password ? errors : false}
                css="w-full"
                error={result?.error}
              />
            </div>
            <div>
              <InputGlobal
                formCamp="repeat_password"
                type="password"
                label="Repetir senha "
                placeholder="Digite novamente a senha"
                register={register}
                validations={{ required: true }}
                required={true}
                errors={errors?.repeat_password ? errors : false}
                css="w-full"
                error={result?.error}
              />
            </div>
            <div>
              <InputGlobal
                formCamp="email"
                type="email"
                label="Email"
                placeholder="Digite seu email"
                register={register}
                validations={{ required: true }}
                required={true}
                errors={errors?.email ? errors : false}
                css="w-full"
                error={result?.error}
              />
            </div>
          </form>
        </DialogBody>
        <DialogFooter>
          <ButtonGlobal
            className="ml-auto"
            click={handleSubmit(onSubmit)}
            color="blue"
            text={'Cadastrar'}
          />
        </DialogFooter>
        {result?.sucess && <MsgSucess reset={resetInfo} />}
      </Dialog>
    </>
  );
}
